import Note from '@components/ui/InfoNote';
import {
  PersonQuotaWarning,
  PriceQuotaWarning,
} from '@components/cards/TravelPlanning/utils';

import { WarningBoxWrapper } from './styled';

interface Props {
  showGuestsWarning?: boolean;
  showGuestsWarningPrice?: boolean;
  showEmptyVariationGuestsNote?: boolean;
  personQuota: number;
}

const TourSelectionWarnings = ({
  showGuestsWarning,
  showGuestsWarningPrice,
  showEmptyVariationGuestsNote,
  personQuota,
}: Props) => {
  return (
    <>
      {showEmptyVariationGuestsNote && (
        <div>
          <Note backgroundColor='lightClearBlue' color='clearBlue'>
            Uygun paket bulunamadı.
          </Note>
        </div>
      )}
      {showGuestsWarning ? (
        <WarningBoxWrapper>
          {PersonQuotaWarning(
            {
              personQuota,
            },
            {
              padding: '14px 0px 14px 4px',
              width: 'calc(100% + 40px)',
            }
          )}
        </WarningBoxWrapper>
      ) : null}
      {showGuestsWarningPrice ? (
        <WarningBoxWrapper>
          {PriceQuotaWarning({
            padding: '14px 0px 14px 4px',
            width: 'calc(100% + 40px)',
          })}
        </WarningBoxWrapper>
      ) : null}
    </>
  );
};

export default TourSelectionWarnings;
